import { Time, Framerate } from '../media/time'

export class TrackItem {
  id?: string
  timebase: Framerate
  duration: Time
  start: Time
  end: Time
  tIn: Time
  tOut: Time

  static parse (json) {
    const i = new TrackItem()
    json = { ...json }
    Object.assign(i, json)
    i.timebase = Framerate.parse(json.timebase)
    i.duration = Time.parse(json.duration, i.timebase)
    i.start = Time.parse(json.start, i.timebase)
    i.end = Time.parse(json.end, i.timebase)
    i.tIn = Time.parse(json.t_in, i.timebase)
    i.tOut = Time.parse(json.t_out, i.timebase)
    delete (i as any).t_in
    delete (i as any).t_out
    return i
  }

  serialize () {
    const res: any = { ...this }
    res.t_in = this.tIn.serialize()
    res.t_out = this.tOut.serialize()
    res.start = this.start.serialize()
    res.end = this.end.serialize()
    res.duration = this.duration.serialize()
    res.timebase = this.timebase.serialize()
    delete res.tIn
    delete res.tOut
    return res
  }
}

export class Track {
  items: TrackItem[]
  locked = false

  constructor () {
    this.items = []
  }

  static parse (json) {
    const t = new Track()
    Object.assign(t, json)
    t.items = json.items.map(x => TrackItem.parse(x))
    return t
  }

  serialize () {
    const res: any = { ...this }
    res.items = this.items.map(x => x.serialize())
    delete res.locked
    return res
  }
}

export class Sequence {
  tracks: Track[]
  timebase: Framerate

  constructor () {
    this.tracks = []
  }

  static parse (json) {
    const s = new Sequence()
    Object.assign(s, json)
    s.tracks = json.tracks.map(x => Track.parse(x))
    s.timebase = Framerate.parse(json.timebase)
    return s
  }

  serialize () {
    const res: any = { ...this, type: 'sequence' }
    res.tracks = this.tracks.map(x => x.serialize())
    res.timebase = this.timebase.serialize()
    return res
  }
}

export class Clip {
  id?: string
  timebase: Framerate
  duration: Time
  tIn: Time
  tOut: Time

  is_master: boolean
  is_subclip: boolean
  master_id?: string
  source_asset_id?: number
  source_bundle_id?: number

  static parse (json) {
    const c = new Clip()
    json = { ...json }
    Object.assign(c, json)
    c.timebase = Framerate.parse(json.timebase)
    c.duration = Time.parse(json.duration, c.timebase)
    c.tIn = Time.parse(json.t_in, c.timebase)
    c.tOut = Time.parse(json.t_out, c.timebase)
    delete (c as any).t_in
    delete (c as any).t_out
    return c
  }

  serialize () {
    const res: any = { ...this, type: 'clip' }
    res.t_in = this.tIn.serialize()
    res.t_out = this.tOut.serialize()
    res.duration = this.duration.serialize()
    res.timebase = this.timebase.serialize()
    delete res.tIn
    delete res.tOut
    return res
  }
}

export class Bin {
  children: (Clip|Bin|Sequence)[]
  name: string

  static parse (json) {
    const b = new Bin()
    Object.assign(b, json)
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    b.children = json.children.map(_parseChild)
    return b
  }

  serialize () {
    const res: any = { ...this, type: 'bin' }
    res.children = this.children.map(x => x.serialize())
    return res
  }
}

export function _parseChild (json): Clip|Bin|Sequence|undefined {
  if (json.type === 'bin') {
    return Bin.parse(json)
  } else if (json.type === 'clip') {
    return Clip.parse(json)
  } else if (json.type === 'sequence') {
    return Sequence.parse(json)
  }
  return undefined
}
